var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

$(document).ready(function ($){

    setTimeout(function (){
        $('.affirm-modal-trigger').attr('tabindex','-1');
        $('#dummy-chat-button-iframe').attr('title','Chat');
    },5000);

    if ($(window).width()>767) {
        var navOffset = $('.header-section').offset().top;
        var navSectionHeight = $('.header-section').height(); // +4 for border
    } else {
        var navOffset = $('.nav-section-mobile').offset().top;
        var navSectionHeight = $('.nav-section-mobile').height()+2; // +4 for border
    }

    if ($('.collection-title').offset() != null) {
        var ctOffset = $('.collection-title').offset().top;
    }

    if ($('.wd-filters-sorter').offset() != null) {
        if ($(window).width()>767) {
            var filterOffset = $('.wd-filters-sorter').offset().top+20; // +20 for title padding on desktop
        } else {
            var filterOffset = $('.wd-filters-sorter').offset().top;
        }
    }


    const collectionTitleHeight = $('.collection-title').height();
    const filterHeight = $('.wd-filters-sorter').height();

    $(window).scroll(function (){

        let scrollTop = $(document).scrollTop();
        if (scrollTop>navOffset) {
            if (($(window).width()>767) ) {
                $('.header-section').addClass('sticky');
                $('body').css('padding-top',navSectionHeight);
            } else {
                $('.nav-section').addClass('sticky');
                $('body').css('padding-top',navSectionHeight);
            }
        } else {
            $('.header-section').removeClass('sticky');
            $('.nav-section').removeClass('sticky');
            $('body').css('padding-top',0);
        }

        if (ctOffset != null) {
            if(scrollTop>(ctOffset-navSectionHeight)) {
                $('.collection-title').addClass('sticky');
                $('body').css('padding-top',(navSectionHeight+collectionTitleHeight));
            } else {
                $('.collection-title').removeClass('sticky');
            }
        }

        if (filterOffset != null) {
            if(scrollTop>(filterOffset-navSectionHeight-collectionTitleHeight)) {
                $('.wd-filters-sorter').addClass('sticky');
                $('body').css('padding-top',(navSectionHeight+collectionTitleHeight+filterHeight));
            } else {
                $('.wd-filters-sorter').removeClass('sticky');
            }
        }
    });


    /* CART NOTE UPDATE FROM CART DROPDOWN -> BEGIN */
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms

    $('body').on('keyup','#popout-note', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    $('body').on('keydown','#popout-note', function () {
        clearTimeout(typingTimer);
    });

    function doneTyping () {
        var note = $('body #popout-note').val();

        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            type: 'post',
            data: {
                note: note,
            },
            success: function(item) {
                //if on cart page, update note textarea
                if ($('#shopify-section-cart-template').length) {
                    $('#shopify-section-cart-template #note').val(note);
                }
            },
            error: function(XMLHttpRequest) {
                console.log('cart note update error')
            }
        });
    }

    //if on cart page then update cart dropdown as well
    $('#shopify-section-cart-template #note').on('keyup',function (){
        $('body #popout-note').val($(this).val()).trigger('keyup');
    });
    $('#shopify-section-cart-template #note').on('keydown',function (){
        $('body #popout-note').trigger('keydown');
    });
    /* CART NOTE UPDATE FROM CART DROPDOWN -> END */


    /* MOBILE NAV DROPDOWN ADDON */
    $('.nav-section-mobile .dropdown').click(function (){
        var $item = $(this);
        setTimeout(function (){
            if ($item.hasClass('slicknav_open')) {
                $item.siblings().css('display','none');
            } else {
                $item.siblings().css('display','block');
            }
        },100);
    });

    /* MOBILE NAV DROPDOWN ADDON END */




    /*
        COUNPON CODES -> BEGIN
    */


    var dc = getUrlParameter('dc');
    if (dc) {
        if (dc !== '') {
            setCookie('bwo_applied_discount',dc,0.41); //0.041 days ~ 1 hour
        }
    }


    /*
        COUNPON CODES -> END
    */


    $('.search-trigger').click(function () {
        $('.top_bar_search').toggleClass('d-none');
    });
});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
